"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var colorsV2_1 = __importDefault(require("../../../assets/jss/colorsV2"));
var constants_1 = __importDefault(require("../../../config/constants"));
var Address_1 = __importDefault(require("../../../shared/components/input/Address"));
var styles_2 = __importDefault(require("../styles"));
var PersonalInformation = function (_a) {
    var _b;
    var updateField = _a.updateField, personalInformationFields = _a.personalInformationFields, handleAddressSelect = _a.handleAddressSelect, address = _a.address, onBack = _a.onBack;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, react_1.useEffect)(function () {
        window.scrollTo(0, 0);
        var gridItem = document.getElementById('address1');
        if (gridItem) {
            gridItem.focus();
        }
    }, []);
    return (react_1.default.createElement(Grid_1.default, { item: true, xs: 12, container: true, alignItems: "center", justifyContent: "center", style: { marginBottom: theme.spacing(2) } },
        react_1.default.createElement(Grid_1.default, { className: classes.fieldContainer, item: true, xs: 12, lg: 10 },
            react_1.default.createElement(Address_1.default, { address: address, handleAddressChange: handleAddressSelect, showMandatory: true, fieldVariant: (_b = constants_1.default.FIELDS_VARIANT) !== null && _b !== void 0 ? _b : 'filled', defaultCountryCode: constants_1.default.DEFAULT_COUNTRY_CODE, defaultStateCode: constants_1.default.DEFAULT_STATE_CODE }),
            personalInformationFields.map(function (field) {
                var onFieldChange = function (value) {
                    updateField(field.key, value);
                };
                var inputProps = {
                    variant: constants_1.default.FIELDS_VARIANT,
                    autoComplete: field.key === 'phone' ? 'tel' : 'on',
                    helperText: field.key === 'phone' ? t('address.phone', 'Example: (123) 456-7890') : undefined
                };
                var labelProps = {
                    useAlternateTextField: true,
                    isRequiredLabel: true,
                    labelStyle: {
                        margin: theme.spacing(2, 0, 1, 2),
                        color: colorsV2_1.default.palette.neutralsN700.hex()
                    }
                };
                return (react_1.default.createElement(package_1.FieldRenderer, { key: field.key, field: field, onChange: onFieldChange, className: classes.field, inputProps: inputProps, labelProps: labelProps }));
            }))));
};
exports.default = PersonalInformation;
//# sourceMappingURL=PersonalInformation.js.map